import createIcon from '../../createIcon';

/**
 * @component @name Subscriptions
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgOEg0VjZIMjBWOFpNMTggMkg2VjRIMThWMlpNMjIgMTJWMjBDMjIgMjEuMSAyMS4xIDIyIDIwIDIySDRDMi45IDIyIDIgMjEuMSAyIDIwVjEyQzIgMTAuOSAyLjkgMTAgNCAxMEgyMEMyMS4xIDEwIDIyIDEwLjkgMjIgMTJaTTE2IDE2TDEwIDEyLjczVjE5LjI2TDE2IDE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Subscriptions = createIcon('Subscriptions', [
  [
    'path',
    {
      d: 'M20 8H4V6H20V8ZM18 2H6V4H18V2ZM22 12V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V12C2 10.9 2.9 10 4 10H20C21.1 10 22 10.9 22 12ZM16 16L10 12.73V19.26L16 16Z',
      key: '1szdq1',
    },
  ],
]);

export default Subscriptions;
